import React, { useImperativeHandle, useRef, useState } from "react";
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import DataGrid, { Column, Pager, Paging, FilterRow, Editing, DataGridRef, Button as GridButton } from 'devextreme-react/data-grid';
import { prodottiDataSource } from '../../datasources/prodottiDataSource';
import { dataGridErrorHandling } from '../../utils/errorHandling';
import PopupUpdateQtaOrder, { OrderQtaPopupHandle } from '../../components/popupUpdateQtaOrder/popupUpdateQtaOrder';
import PopupProductSheet, { ProductSheetPopupHandle } from '../../components/popupProductSheet/popupProductSheet';
import './popupOrderProduct.scss';
import { useTranslation } from 'react-i18next';

type Props = {
    onChanged: () => void
}

export type OrderProductPopupHandle = {
    new: (idOrdine: number) => void
}

type state = {
    idOrdine: number,
    idDettaglio: number,
    visible: boolean,
    datasource: any
}

const PopupOrderProduct: React.ForwardRefRenderFunction<OrderProductPopupHandle, Props> = (props, ref) => {
    const [state, setState] = useState<state>({ idOrdine: 0, idDettaglio: 0, visible: false, datasource: ""});
    const gridRef = useRef<DataGridRef>(null);
    const ordineqtaRef = useRef<OrderQtaPopupHandle>(null);
    const productsheetRef = useRef<ProductSheetPopupHandle>(null);
    const { t } = useTranslation();

    const [isChanged, setIsChanged] = useState<boolean>(false);
    
    const imgUrl = "product.jpg";   

    const isVisualizzaScheda = (e:any) => e.row.data.imageUrl;

    function hideInfo() {
        if (isChanged) {
            props.onChanged();
            setIsChanged(false);
        }
            
        setState({ idOrdine: 0, idDettaglio: 0, visible: false, datasource: "" });
    }

    useImperativeHandle(ref, () => ({

        new(idOrdine) {

            setState({
                idOrdine: idOrdine,
                idDettaglio: 0,
                visible: true,
                datasource: prodottiDataSource(idOrdine)
            });
        }
    }));

    function refreshGrid() {
        gridRef.current?.instance().refresh();
        // console.log('refresh dettaglio prodotti');
    }

    function new_click(e: any) {
        ordineqtaRef.current?.new(state.idOrdine, e.row.data.codice);
    }

    function link_click(e: any) {
        productsheetRef.current?.show(e.row.data.imageUrl);
    }

    function product_inserted() {
        gridRef.current?.instance().refresh();
        setIsChanged(true);
    }

    return (<React.Fragment>        
        <Popup
            title={t ('catalogoProd')}
            visible={state.visible}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={false}
            showTitle={true}
            fullScreen={true}
            onHidden={hideInfo}            
            container=".dx-viewport"
        >
            <Position
                at="center"
                my="center"
                of=""
                collision="fit"
            />
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="center"
                options={{
                    text: t('chiudi'),
                    onClick: hideInfo,
                }}
            />

            <DataGrid
                key="codice"
                ref={gridRef}
                className={'dx-card wide-card'}
                dataSource={state.datasource}
                showBorders={false}
                focusedRowEnabled={true}
                errorRowEnabled={false}
                defaultFocusedRowIndex={0}
                defaultSelectionFilter=""
                columnAutoWidth={true}
                columnHidingEnabled={true}
                onRowUpdating={function (e) {
                    e.newData = Object.assign({}, e.oldData, e.newData);
                }}
                onDataErrorOccurred={dataGridErrorHandling}
            >
                <Editing
                    mode="form"
                    allowUpdating={true}
                    allowAdding={false}
                    allowDeleting={false}>
                </Editing>

                <Paging defaultPageSize={10} />
                <Pager showPageSizeSelector={true} showInfo={true} />
                <FilterRow visible={true} />

                <Column type='buttons' >
                    <GridButton hint={t ('selezionaProd')} icon="product" onClick={new_click} />
                    <GridButton hint={t ('visualizzascheda')} icon="link" onClick={link_click} visible={isVisualizzaScheda} />
                </Column>

                <Column dataField={'padreCodice'} caption={t ('padreCodice')} hidingPriority={4} allowEditing={false} showEditorAlways={false}/>
                <Column dataField={'codice'} caption={t ('codice')} hidingPriority={3} allowEditing={false} showEditorAlways={false}/>
                <Column dataField={'descrizione'} caption={t ('descrizione')} hidingPriority={2} allowEditing={false} />
                <Column dataField={'prezzoVendita'} width={150} caption={t ('prezzoVendita')} hidingPriority={1} />
                {/* <Column dataField={'sampleOmaggioNumero'} width={150} caption="Sample" hidingPriority={3} />
                <Column dataField={'shopperOmaggioNumero'} width={150} caption="Shopper" hidingPriority={2} />
                <Column dataField={'mouiletteOmaggioNumero'} width={155} caption="Mouilette" hidingPriority={1} /> */}
            
            </DataGrid>
        </Popup>

        <PopupUpdateQtaOrder ref={ordineqtaRef} onChanged={refreshGrid} onInserted={product_inserted} ></PopupUpdateQtaOrder>
        <PopupProductSheet ref={productsheetRef} ></PopupProductSheet>

    </React.Fragment>
    );
}

export default React.forwardRef(PopupOrderProduct);

